module.exports = __webpack_public_path__ + "img/logo-white-text.e0935aeb.png";